import { createReducer, on } from '@ngrx/store';

import { ModalState } from '../../interfaces/modal.interface';
import { ModalActions } from '../actions';

export const initialState: ModalState = {
  modal: null,
  returnTarget: null,
};

const modalReducer = createReducer(
  initialState,
  on(ModalActions.openModal, (state, { modal, returnTarget }) => ({
    ...state,
    modal: { ...modal },
    returnTarget,
  })),
  on(ModalActions.closeModal, () => initialState)
);

export function reducer(state: ModalState, action: ModalActions.ModalActionsUnion): ModalState {
  return modalReducer(state, action);
}
